module.exports = __webpack_public_path__ + "c9abb45569fb88471eab4f05e845d289.svg";